// Lazy-loaded components for code splitting
const PermissionList = () =>
    import(/* webpackChunkName: "permission" */ "./pages/ListPage.vue");
const PermissionDetail = () =>
    import(/* webpackChunkName: "permission" */ "./pages/FormPage.vue");
const PermissionIndex = () =>
    import(/* webpackChunkName: "permission" */ "./pages/IndexPage.vue");
export default [
    {
        path: "/permission",
        component: PermissionIndex,
        redirect: "/permission/list",
        name: "permission",
        children: [
            {
                path: "list",
                component: PermissionList,
                name: "permission.list",
            },
            {
                path: "create",
                component: PermissionDetail,
                name: "permission.create",
                props: { create: true },
            },
            {
                path: "edit/:id",
                component: PermissionDetail,
                name: "permission.edit",
                props: { create: false },
            },
        ],
    },
];
